import { render, staticRenderFns } from "./EntityAdditionalPictures.vue?vue&type=template&id=1bbd4133&scoped=true"
import script from "./EntityAdditionalPictures.vue?vue&type=script&lang=js"
export * from "./EntityAdditionalPictures.vue?vue&type=script&lang=js"
import style0 from "./EntityAdditionalPictures.vue?vue&type=style&index=0&id=1bbd4133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd4133",
  null
  
)

export default component.exports